import { clsx } from 'clsx';
import { FC, PropsWithChildren } from 'react';
import { OldPrice } from 'molecules/OldPrice';
import { Price } from 'molecules/Price';
import { useTranslations } from 'modules/i18n/useTranslations';
import {
  IAdaptedBasicProduct,
  IAdaptedListProduct,
  IProductVariant,
} from 'commerce/scayle/utils/adapter/types';
import styles from './styles.module.css';

export const ProductDiscount: FC<{
  product: IAdaptedBasicProduct | IAdaptedListProduct;
}> = ({ product }) => {
  const t = useTranslations();
  return (
    <div className={styles.discount}>
      <OldPrice
        amount={product.price.recommendedRetailPrice}
        currencyCode={product.price.currencyCode}
        className={styles.oldPrice}
      />
      <span className={styles.discountPercentage}>
        {t('product.tile.discountPercent', {
          discount: product.discountPercentage,
        })}
      </span>
    </div>
  );
};

export const ProductPrice: FC<{
  activeVariant?: IProductVariant;
  className?: string;
  currencyClassName?: string;
}> = ({ activeVariant, className, currencyClassName }) => {
  return !activeVariant?.price ? null : (
    <Price
      amount={activeVariant.price.withTax}
      currencyCode={activeVariant.price.currencyCode}
      className={clsx(styles.price, className)}
      currencyClassName={currencyClassName}
    />
  );
};

export const PriceInfo: FC<PropsWithChildren & { className?: string }> = ({
  children,
  className = '',
}) => {
  return <div className={clsx(styles.priceInfo, className)}>{children}</div>;
};
